<template>
  <vx-card class="insert-sale-invoice main-box top-zero-radius">

    <div class="date-items">
      <button class="prev-date-btn" @click="changeTableDay(-1)">
        {{ $t('sales.invoices.labels.lastWeek') }}
      </button>
      <div class="date-items">
        <div class="date-content">
          <template v-for="i in 7">
            <button class="date-btn"
                    :class="selectedTableDay > -1 && i === selectedTableDay || selectedTableDay === -1 && i - 1 === weekIndex ? 'active' : ''"
                    @click="setTableDate(i)">
              {{ getTableDate($validator('moment.dateWithWeek'), (futureDays * 7) + i - weekIndex - 1) }}
              <span v-if="tableDayReserveCount[i - 1] > 0" class="day-reserve-count">
                {{ tableDayReserveCount[i - 1] }}
              </span>
            </button>
          </template>

        </div>
      </div>
      <button class="next-date-btn" @click="changeTableDay(+1)" :disabled="futureDays === 0 && $route.name === 'insertPastSaleInvoice'">
        {{ $t('sales.invoices.labels.futureWeek') }}
      </button>
    </div>

    <div class="time-table">
      <div class="time-table-body">
        <div v-if="timesList.length > 0"
             class="court-row time-label">
          <div class="court-name">{{ $t('sales.invoices.labels.timeCourt') }}</div>
          <select-time v-for="(item, time_index) in timesList[0].times"
                       :time="item.time"
                       :court="item.court"
                       :price="0"
                       :term-id="item.term_id"
                       :is-label="true"
                       :disabled="true"
                       :date="getTableDate()"
                       :selected-times="selectedTimes"/>
        </div>
        <div v-if="courtItem.times && courtItem.times.length > 0"
             class="court-row"
             v-for="(courtItem, court_index) in timesList"
             :key="`court_${court_index}`">
          <div class="court-name">{{ courtItem ? courtItem.court_name : '' }}</div>
          <select-time v-for="(item, time_index) in courtItem.times"
                       :time="item.time"
                       :court="item.court"
                       :price="item.price"
                       :term-id="item.term_id"
                       :week-day="selectedTableDay"
                       :customer="item.customer"
                       :disabled="getTableItemDisabled(item)"
                       :date="getTableDate()"
                       :selected-times="selectedTimes"
                       :type="item.type"
                       :current-time="getCurrentHour(item)"
                       @showUser="handleShowProfile(item)"
                       @time:selected="handleTimeSelected($event)"
                       @time:unselected="handleTimeUnselected($event)"/>
        </div>
      </div>
    </div>



    <!-- type selector -->
    <vs-prompt
            color="danger"
            :buttons-hidden="true"
            title=""
            @close="$router.replace({name: 'saleInvoices'})"
            :active.sync="selectInvoiceTypeStatusPrompt">

      <div class="prompt-content p-3">

        <button class="select-type-button"
                @click="handleSelectInvoiceType(1)">
          <custom-icon class="ml-2"
                       icon="BUY"
                       width="50px"
                       height="25px"
                       color="primary"/>

          <vs-spacer/>

          <span class="ml-2">
            {{ $t('sales.invoices.actionTypes.present') }}
          </span>

          <vs-spacer/>
        </button>

        <button class="select-type-button mt-3"
                @click="handleSelectInvoiceType(2)">
          <custom-icon class="ml-2"
                       icon="PHONE"
                       width="50px"
                       height="25px"
                       color="primary"/>

          <vs-spacer/>

          <span class="ml-2">
            {{ $t('sales.invoices.actionTypes.tel') }}
          </span>

          <vs-spacer/>
        </button>
      </div>
    </vs-prompt>
    <!-- /type selector -->

    <!-- show user details prompt -->
    <vs-prompt
      class="medium-prompt p-0"
      :buttons-hidden="true"
      title=""
      :active.sync="showUserPromptStatus"
      @close="showUserPromptStatus = true">

      <div class="prompt-header p-3 w-full" :class="[!this.$vs.rtl ? 'rtl-only' : '']">
        <vs-row>
          <vs-col class="w-1/5 useral-font-weight-medium text-success cursor-pointer">
            <!--            <div @click="editUserPromptStatus = true">-->
            <!--              <custom-icon icon="EDIT" color="warning"/>-->
            <!--            </div>-->
          </vs-col>

          <vs-spacer/>

          <vs-col class="w-1/2 text-center useral-font-weight-bold text-md">
            {{ $t('users.user.profile.title') }}
          </vs-col>

          <vs-spacer/>

          <vs-col class="w-1/5 text-right useral-font-weight-medium text-danger cursor-pointer">
            <div @click="showUserPromptStatus = false">
              <custom-icon icon="TIMES-CIRCLE" color="danger"/>
            </div>
          </vs-col>
        </vs-row>
      </div>

      <div class="prompt-content">
        <template>
          <keep-alive>
            <sale-invoice-modal :user-id="selectedUser.id" :invoice-id="selectedUser.invoiceId"/>
          </keep-alive>
        </template>
      </div>

    </vs-prompt>

    <!-- show selected times prompt -->
    <vs-prompt
        class="very-big-prompt p-0"
        :buttons-hidden="true"
        title=""
        :active.sync="confirmTimesPromptStatus"
        @close="confirmTimesPromptStatus = true">

      <div class="prompt-header p-3 w-full" :class="[!this.$vs.rtl ? 'rtl-only' : '']">
        <vs-row>
          <vs-col class="w-1/5 useral-font-weight-medium text-success cursor-pointer">
            <div @click="handleClick('showPaymentModal')">
              <custom-icon icon="SAVE_PAY" color="success"/>
            </div>
          </vs-col>

          <vs-spacer/>

          <vs-col class="w-1/2 text-center useral-font-weight-bold text-md">
            {{ $t('sales.invoices.labels.confirm') }}
          </vs-col>

          <vs-spacer/>

          <vs-col class="w-1/5 text-right useral-font-weight-medium text-danger cursor-pointer">
            <div @click="confirmTimesPromptStatus = false">
              <custom-icon icon="TIMES-CIRCLE" color="danger"/>
            </div>
          </vs-col>
        </vs-row>
      </div>

      <div class="prompt-content">
        <template>
          <keep-alive>
            <insert-sale-invoice :action-type="newInvoice.actionType" :selected-times="selectedTimes"/>
          </keep-alive>
        </template>
      </div>

    </vs-prompt>

    <vs-button id="setTimeSelected" class="useral-action-button" @click="handleShowReserveConfirm"/>
  </vx-card>
</template>

<script>
import axios from "axios";
import moment from "moment-jalaali";
import {getTimes} from "../../../../../http/requests/times";
import {getCourts} from "../../../../../http/requests/courts";
import {getReservableTimes} from "../../../../../http/requests/sales";
import SelectTime from "../../../../../components/reserveTime/selectTime";
import CustomIcon from "../../../../../components/customIcon/customIcon";
import InsertSaleInvoice from '../insert/insertSaleInvoice'
import {showLoading, hideLoading, getTimeFromServer} from "../../../../../assets/js/functions";
import SaleInvoiceModal from "../invoice/saleInvoiceModal";

export default {
  name: "insertTimeSaleInvoice",
  components: {SaleInvoiceModal, CustomIcon, SelectTime, InsertSaleInvoice},
  metaInfo() {
    return {
      title: this.$t('sales.invoices.labels.selectTime')
    }
  },
  props: {
    multiSelect: {
      type: Boolean,
      default: () => { return true }
    },
    inModal: {
      type: Boolean,
      default: () => { return false }
    }
  },
  data() {
    return {
      confirmTimesPromptStatus: false,
      selectInvoiceTypeStatusPrompt: false,
      showUserPromptStatus: false,
      currentTime: moment(getTimeFromServer()).format(this.$validator('moment.date')),
      futureDays: 0,
      weekIndex: 0,
      getCurrentHourTimer: 0,
      selectedTableDay: -1,
      selectedUser: {},
      timesList: [],
      courtsList: [],
      reservedList: [],
      selectedTimes: {},
      tableDayReserveCount: [],
      reserveTypeStatus: 'date',
      newInvoice: {
        id: {
          value: '',
          isValid: true
        },
        actionType: {
          value: 1,
          label: this.$t('sales.invoices.actionTypes.present')
        },
        status: {},
        user: {
          id: 0,
          name: {
            value: '',
            isValid: true
          }
        },
        date: {
          value: moment(getTimeFromServer()).format(this.$validator('moment.date')),
          isValid: true
        },
        finalPrice: 0,
        totalPrice: 0,
      },
      invoiceProcesses: [
        {
          label: this.$t('sales.invoices.processTypes.preInvoice'),
          value: 1
        },
        {
          label: this.$t('sales.invoices.processTypes.invoice'),
          value: 2
        }
      ],
      actions: [
        {
          toolbar: [
            {
              id: 'setTimeSelected',
              icon: 'CHECK',
              iconPack: 'useral',
              color: 'success',
              badge: {
                value: 0
              }
            }
          ],
          leftToolbar: [
            {
              id: {name: 'saleInvoices'},
              type: 'link',
              icon: 'CHEVRON_LEFT',
              iconPack: 'useral'
            }
          ]
        }
      ]
    }
  },
  created() {
    if (!this.inModal) {
      setTimeout(() => {
        this.$store.dispatch('updateNavbarActions', this.actions[0])
        this.newInvoice.status = this.invoiceProcesses[0]
      }, 100)
    }
    this.currentTime = getTimeFromServer()

    this.weekIndex = (moment(this.currentTime).day() + 1) % 7
    this.selectedTableDay = this.weekIndex + 1

    this.getTimes()
    this.getCourts()
    this.getReservableTimes()
    this.getReserveTableCount()
  },
  mounted () {
    setTimeout(() => {
      showLoading()
    }, 480)

    this.getCurrentHourTimer = setTimeout(() => {
      this.getCurrentHourTimer = 0
    }, 60000 - parseInt(moment(this.currentTime).format(this.$validator('moment.second'))) * 1000)
  },
  methods: {
    getCurrentHour (item) {
      return moment(this.currentTime).format(this.$validator('moment.dateHour')) === `${item.date} ${item.time.start_time.split(':')[0]}`
    },
    getDateBtnDisabled (i) {
      if (this.$route.name === 'insertPastSaleInvoice') {
        return this.futureDays === 0 && i - 1 > this.weekIndex
      } else {
        return this.futureDays === 0 && i - 1 < this.weekIndex
      }
    },
    getTableItemDisabled (item) {
      return parseInt(item.price) === 0 || item.status === 2 || item.status === 0 || item.customer
    },
    getTableDate(formatValue = this.$validator('moment.date'), days = (this.futureDays * 7) + this.selectedTableDay - this.weekIndex - 1) {
      return moment(this.currentTime).add(days, 'days').format(formatValue)
    },
    setTableDate(index = this.selectedTableDay) {
      this.selectedTableDay = index
      const days = (this.futureDays * 7) + index - this.weekIndex - 1
      this.timesList = []
      this.getReservableTimes(days)
    },
    changeTableDay(status) {
      if (status < 0) {
        this.futureDays -= 1
      } else {
        this.futureDays += 1
      }
      this.timesList = []
      this.setTableDate()
      this.getReserveTableCount()
    },
    getReservableTimes(days) {
      switch (this.reserveTypeStatus) {
        case 'date':
          this.getReservableTimesBaseDate(days)
          break
      }
    },
    getReservableTimesBaseDate(days) {
      showLoading()
      let filters = [`date=${this.getTableDate(this.$validator('moment.date'), days)}`]
      filters.push('type=4')
      getReservableTimes(1, filters).then((response) => {
        const data = response.data.data
        let totalTimes = {}
        data.forEach(time => {
          if (!totalTimes[`court_${time.court.id}`]) {
            let court = time.court
            court.times = []
            totalTimes[`court_${time.court.id}`] = court
          }

          switch (time.status) {
            case 0:
              time.type = 'closed'
              break

            case 1:
              time.type = 'selectable'
              break

            case 2:
              time.type = 'reserved'
              break
          }
          totalTimes[`court_${time.court.id}`].times.push(time)
        })
        this.timesList = Object.values(totalTimes)
        hideLoading()
      })
        .catch(error => {
          hideLoading()
        })
    },
    getTimes() {
      getTimes().then(response => {
        const times = response.data.data
        times.forEach((time) => {
          this.timesList.push({
            id: time.id,
            startTime: time.start_time.substr(0, 5),
            endTime: time.end_time.substr(0, 5)
          })
        })
      })
    },
    getCourts() {
      getCourts().then((response) => {
        const courts = response.data.data
        courts.forEach((court) => {
          this.courtsList.push({
            id: court.id,
            name: court.name
          })
        })
      })
    },
    handleShowReserveConfirm () {
      if (Object.values(this.selectedTimes).length > 0) {
        this.confirmTimesPromptStatus = true
      } else {
        this.$vs.notify({
          title: this.$t('alert.error.title'),
          text: this.$t('sales.invoices.validators.noTime'),
          color: 'danger',
          icon: 'icon-alert-circle',
          iconPack: 'feather',
          time: 2400
        })
      }
    },
    handleSelectInvoiceType (type) {
      this.newInvoice.actionType = {
        value: type,
        label: type === 1 ? this.$t('sales.invoices.actionTypes.present') : this.$t('sales.invoices.actionTypes.tel')
      }
      this.selectInvoiceTypeStatusPrompt = false
    },
    handleTimeSelected(selectedTime) {
      delete selectedTime.court.times
      this.selectedTimes[`${selectedTime.date}_${selectedTime.time.id}_${selectedTime.court.id}`] = selectedTime
      if (this.multiSelect) {
        setTimeout(() => {
          let actions = JSON.parse(JSON.stringify(this.actions))
          actions[0].toolbar[0].badge.value = Object.values(this.selectedTimes).length
          this.$store.dispatch('updateNavbarActions', actions[0])
        }, 100)
        this.getReserveTableCount()
      } else {
        this.$emit('selected', this.selectedTimes)
      }

    },
    getReserveTableCount () {
      const selectedTimes = Object.keys(this.selectedTimes)
      let timeCounts = []
      for (let i = 1; i <= 7; i++) {
        let count = 0
        const date = this.getTableDate(this.$validator('moment.date'), (this.futureDays * 7) + i - this.weekIndex - 1)
        selectedTimes.forEach((time) => {
          if (time.split('_')[0] === date) {
            count++
          }
        })
        timeCounts.push(count)
      }
      this.tableDayReserveCount = timeCounts
    },
    handleTimeUnselected(unselectedTime) {
      delete this.selectedTimes[`${unselectedTime.date}_${unselectedTime.time.id}_${unselectedTime.court.id}`]
      setTimeout(() => {
        let actions = JSON.parse(JSON.stringify(this.actions))
        actions[0].toolbar[0].badge.value = Object.values(this.selectedTimes).length
        this.$store.dispatch('updateNavbarActions', actions[0])
      }, 100)
      this.getReserveTableCount()
    },
    handleShowProfile(item) {
      if (item.customer) {
        this.selectedUser = item.customer
        this.selectedUser.invoiceId = item.invoice_id
        this.showUserPromptStatus = true
        // let routeData = this.$router.resolve({name: 'saleInvoice', params: {id: item.invoice_id}})
        // window.open(routeData.href, '_blank')
      }
    },
    handleClick(id) {
      document.getElementById(id).click()
    },
  },

  watch: {
    getCurrentHourTimer: {
      handler (val) {
        if (val === 0) {
          this.$forceUpdate()
          this.getCurrentHourTimer = setTimeout(() => {
            this.getCurrentHourTimer = 0
          }, 60000)
        }
      }
    }
  }
}
</script>

<style lang="scss">
@import "../../../../../assets/scss/vuexy/variables";

.insert-sale-invoice {

  .vx-card__body {
    padding: 0 !important;
  }

  .date-items {
    display: flex;
    align-items: center;
    background-color: #f0f0f0;
    border: 1px solid #f0f0f0;

    .prev-date-btn,
    .next-date-btn {
      padding: 5px 20px;
      margin: 10px;
      background-color: #f8f8f8;
      border: 1px solid #cecece;
      border-radius: 0.5rem;

      &:hover:not([disabled]) {
        cursor: pointer;
        background-color: #f0f0f0;
      }

      &:disabled {
        cursor: not-allowed;
      }
    }

    .date-items {
      display: flex;
      justify-content: center;
      flex-grow: 1;
      overflow: auto;
      .date-content {
        display: flex;
        text-align: center;
        overflow-x: auto;
        padding: 5px;

        &::-webkit-scrollbar {
          display: block;
          background: rgba(255, 255, 255, 0.50);
          height: 10px;
          width: 10px;
          border-radius: 0.5rem;
        }

        &::-webkit-scrollbar-thumb {
          display: block;
          background: rgba(206, 206, 206, 1);
          height: 6px;
          border-radius: .5rem;
        }

        .date-btn {
          position: relative;
          padding: 5px 20px;
          margin: 0 5px;
          background-color: #f8f8f8;
          border: 1px solid #cecece;
          border-radius: 0.5rem;
          white-space: nowrap;

          &:hover:not([disabled]) {
            cursor: pointer;
            background-color: #f0f0f0;
          }

          &.active {
            background-color: $sidebar-semi-bg;
            color: #ffffff;

            &:hover {
              background-color: #1b2027;
            }
          }

          &:disabled {
            cursor: not-allowed;
          }

          .day-reserve-count {
            position: absolute;
            bottom: -5px;
            right: 2px;
            color: $success;
          }
        }
      }
    }
  }

  .time-table {
    position: relative;
    height: calc(100vh - 203px);
    overflow-x: auto;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: start;
    flex-wrap: wrap;
    padding: 10px;
    /*padding-left: 170px;*/



    &::-webkit-scrollbar {
      display: block;
      background: rgba(255, 255, 255, 0.50);
      height: 10px;
      width: 10px;
      border-radius: 0.5rem;
    }

    &::-webkit-scrollbar-thumb {
      display: block;
      background: rgba(206, 206, 206, 1);
      height: 6px;
      border-radius: .5rem;
    }

    .time-table-body {
      display: flex;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -ms-flex-direction: column;
      flex-direction: row;
    }

    .court-row {
      display: flex;
      flex-direction: column;
      width: 150px;

      .court-name {
        width: 100%;
        line-height: 60px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: flex;
        align-items: center;
        justify-content: center;
        background: $sidebar-semi-bg;
        /*border-radius: 0.5rem 0.5rem 0 0;*/
        position: sticky;
        top: -11px;
        color: #ffffff;
        font-weight: 500;
        border-left: 1px solid #cdcdcd;
        border-bottom: 1px solid #cdcdcd;
      }

      &:first-child {
        .court-name {
          border-radius: 0.5rem 0 0 0;
          border-left: none;
        }
      }

      &:last-child {
        .court-name {
          border-radius: 0 0.5rem 0 0;
        }

        .select-hour-box:last-child {
          button {
            border-radius: 0 0 0.5rem 0;
          }
        }
      }
    }

    .time-label {
      position: sticky;
      left: -11px;
      /*background-color: #f8f8f8;*/
      z-index: 100;
      width: 100px;

      .select-hour-box {
        .is-label {
          background-color: $sidebar-semi-bg;
          color: #ffffff;
        }
      }

      .select-hour-box:last-child {
        .is-label {
          border-radius: 0 0 0 0.5rem;
        }
      }
    }
  }
}

.action-buttons {
  display: flex;

  button {
    flex: 1;
    line-height: 40px;
    border-radius: .5rem;
    border: none;
    color: #ffffff;
    transition: all .3s ease;
    cursor: pointer;

    &.payment {
      margin-right: 10px;
      background: #33b000cf;

      &:hover {
        background: #33b000;
      }
    }

    &.cancel {
      background: #b00000af;

      &:hover {
        background: #b00000;
      }
    }
  }
}
</style>
